import React, { memo, useEffect, useState } from "react"
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../home/Home"
import Hotels from "../hotels/Hotels"
import HotelDetail from "../hotels/HotelDetail"
import Tour from "../tour/Tour"
import Tours from "../tour/Tours"
import TourDetail from "../tour/TourDetail"
import Cab from "../cab/Cab"
import Bus from "../bus/Bus"
import Visa from "../visa/Visa"
import Package from "../package/Package"
import Train from "../train/Train"
import Cruise from "../cruise/Cruise"
import Insurance from "../insurance/Insurance"
import SignRegister from "../signRegister/SignRegister"
import Login from "../login/Login"
import ForgotPassword from "../forgotPassword/ForgotPassword"
import Profile from "../profile/Profile"
import ChangePassword from "../changePassword/ChangePassword"
import MyBooking from "../myBooking/MyBooking"
import About from "../about/About"
import PrivacyPolicy from "../privacyPolicy/PrivacyPolicy"
import TermsConditions from "../termsConditions/TermsConditions"
import Contact from "../contact/Contact"
import Blog from "../blog/Blog"
import BlogDetail from "../blog/BlogDetail"
import Custom from "../custom/Custom"

import WhatsAppWidget from "../common/whatsapp/WhatsAppWidget"

const Pages = () => {
  return (
    <>
      <BrowserRouter>
        <WhatsAppWidget />
        <Routes>
          <Route path="/tour" element={<Tour />}></Route>
          <Route index path="/flight" element={<Home />} />
          <Route index path="/hotels" element={<Hotels />} />
          <Route index path="/hotelDetail/:id" element={<HotelDetail />} />
          <Route index path="/tours/:id" element={<Tours />} />
          <Route index path="/tour/:cat" element={<Tours />} />
          <Route index path="/tourDetail/:id" element={<TourDetail />} />
          <Route index path="/cab" element={<Cab />} />
          <Route index path="/bus" element={<Bus />} />
          <Route index path="/visa" element={<Visa />} />
          <Route index path="/package" element={<Package />} />
          <Route index path="/train" element={<Train />} />
          <Route index path="/cruise" element={<Cruise />} />
          <Route index path="/insurance" element={<Insurance />} />
          <Route index path="/signRegister" element={<SignRegister />} />
          <Route index path="/login" element={<Login />} />
          <Route index path="/forgotPassword" element={<ForgotPassword />} />
          <Route index path="/profile" element={<Profile />} />
          <Route index path="/changePassword" element={<ChangePassword />} />
          <Route index path="/myBooking" element={<MyBooking />} />
          <Route index path="/about" element={<About />} />
          <Route index path="/privacyPolicy" element={<PrivacyPolicy />} />
          <Route index path="/termsConditions" element={<TermsConditions />} />
          <Route index path="/contact" element={<Contact />} />
          <Route index path="/blog" element={<Blog />} />
          <Route index path="/blogDetail/:id" element={<BlogDetail />} />
          <Route index path="/custom" element={<Custom />} />
          {/* redirect to tour */}
          <Route path="/" element={<Tour />} />
        </Routes>
      </BrowserRouter>
    </>
  )
}

export default Pages
